export default {
  addItem: {
    margin: 10,
  },
  addItemContainer: {
    textAlign: 'right',
  },
  body: {
    padding: 10,
  },
  iconCol: {
    width: 80,
  },
  nameCol: {

  },
  quantityCol: {
    display: 'flex',
    alignItems: 'center',
    width: 150,
  },
  actionCol: {
    width: 80,
  },
  count: {
    fontSize: 18,
    verticalAlign: 'center',
    marginLeft: 10,
    marginRight: 10,
  },
};



// WEBPACK FOOTER //
// ./src/components/TaskProfile/ItemTypesTable/styles.js